import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

import DNotificationBlock from '@/components/DNotificationBlock';
import NotificationIcon from '@/shared/icons/NotificationIcon';
import useNotificationsPolling from '@/hooks/useNotificationsPolling';
import useNotificationsStore from '@/stores/notifications/notifications';
import IconWrapper from '@/shared/components/UI/IconWrapper';
import mixpanel from '@/utils/mixpanel';

const DNotificationHeader = ({ skipDataFetching = false }) => {
  const { fetchMore, loadingMore, hasMore } = useNotificationsPolling(30000, skipDataFetching);
  const updates = useNotificationsStore((state) => state.notifications.updates);
  return (
    <Menu>
      {({ open }) => (
        <>
          {open && (
            <div className="transition-all fixed inset-0 bg-white/90 md:hidden z-10"></div>
          )}
          {open && (
            <div className="transition-all fixed inset-0 top-20 bg-white/90 md:hidden z-10"></div>
          )}
          <MenuButton
            onClick={() => {
              if (!open) {
                mixpanel.track('Notification Bell Opened', {
                  unread_count: updates.filter((u) => !u.seen).length
                });
              }
            }}
            className="inline-flex items-center justify-center gap-2 font-semibold text-black  focus:outline-none data-[hover]:bg-v3-gray-light rounded-v3-xs data-[open]:bg-grey-5 data-[focus]:outline-1 data-[focus]:outline-black inset-1 !w-v3-lg !h-v3-lg"
          >
            <div className="relative w-v3-lg h-v3-lg flex items-center justify-center">
               <IconWrapper size={20}>
                <NotificationIcon className="w-full h-full text-v3-purple-primary" />
              </IconWrapper>
              {updates.filter((update) => !update.seen).length > 0 && (
                <div className="absolute top-[-10px] right-[-5px] size-4 bg-negative-200 rounded-full text-xs flex items-center justify-center text-white leading-none">
                  {updates.filter((update) => !update.seen).length}
                </div>
              )}
            </div>
          </MenuButton>

          <MenuItems
            transition
            anchor="bottom end"
            className="w-full md:w-[400px] mt-[12px] flex flex-col items-start rounded-v3-sm border border-v3-card-border bg-white shadow-v3-card z-20 origin-top-right transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
          >
            <DNotificationBlock
              fetchMore={fetchMore}
              loadingMore={loadingMore}
              hasMore={hasMore}
            />
          </MenuItems>
        </>
      )}
    </Menu>
  );
};

export default DNotificationHeader;
